export const getQueryKey = (key, prefix) => `${prefix || 'li.fi'}-widget-${key}`;
//# sourceMappingURL=queries.js.map